import React, { Component } from "react";
import axios from "axios";
import { AppBar, Toolbar, Box, Tooltip, Typography, Container, CircularProgress } from "@mui/material";
import TaskIcon from "@mui/icons-material/Task";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AssistantIcon from '@mui/icons-material/Assistant';
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import NoteIcon from "@mui/icons-material/Note";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import UploadIcon from "@mui/icons-material/Upload";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ProjectForm from "../../components/forms/ProjectForm_v2/ProjectForm_v2";
import CustomerForm from "../../components/forms/CustomerForm_v2/CustomerForm_v2";
import ContactForm from "../../components/forms/ContactForm_v2/ContactForm_v2";
import EmployeeForm from "../../components/forms/EmployeeForm/EmployeeForm";
import TaskForm_v2 from "../../components/forms/TaskForm_v2/TaskForm_v2";
import LocationForm from "../../components/forms/LocationForm/LocationForm";
import RecordActivity from "../../components/forms/RecordActivityForm/RecordActivity";
import NoteFormv2 from "../../components/forms/NoteForm/NoteFormv2";
import { APIURL, env } from "../../config";
import BulkUploadv2 from "../../components/forms/BulkUploadForm/Bulkuploadv2";
import MsgModalBox from '../../container/MessageModalBox/MsgModalBox';
import IntakeForm from '../../components/forms/IntakeForm/IntakeForm';
import WorkflowForm from "src/components/forms/WorkflowForm/WorkflowForm";
import { Redirect } from 'react-router-dom';
import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTAPIKEY } from '../../config';
import SDRUploadForm from "src/components/forms/SDRUploadForm/SDRUploadForm";

const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY })

const ToolbarAction = ({ title, label, icon, onClick, active }) => (
  <Tooltip title={title}>
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        mx: 0.25,
        px: 0.75,
        py: 0.5,
        borderRadius: 1,
        color: active ? 'primary.main' : 'action.active',
        bgcolor: active ? 'action.selected' : 'transparent',
        borderBottom: active ? '2px solid' : '2px solid transparent',
        borderColor: active ? 'primary.main' : 'transparent',
        transition: 'background-color 0.15s, color 0.15s',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      {icon}
      <Typography
        variant="caption"
        sx={{ fontSize: '0.65rem', lineHeight: 1.2, color: active ? 'primary.main' : 'text.secondary', mt: 0.25, userSelect: 'none' }}
      >
        {label}
      </Typography>
    </Box>
  </Tooltip>
);

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goHome: false,
      showNoteCreated: false,
      isLoading: true,
      employees: {
        list: [{}],
        empType: [],
        empLevel: [],
        empStatus: [],
        currency: [],
        frequency: [],
      },
      loggedToSegment: false,
      customers: { list: [{}], customerType: [], customerStatus: [] },
      projects: { list: [] },
      tasks: { list: [{}], taskType: [] },
      contacts: {
        list: [{}],
        contactType: [],
        designation: [],
        contactStatus: [],
        countryCode: [],
      },
      payers: { list: [] },
      locations: { list: [{}], states: [], locType: [], locStatus: [] },
      forms: { list: [] },
      mapRender: this.props.mapRender || this.props.location.state.mapRender || "task",
      renderComponent: null,
    };
  }

  logToSegment = async () => {
    if (this.state.loggedToSegment) {
      return;
    }
    let page = String(window.location.href).split("/").pop()
    if (page.includes("fieldworker") || page === "" || page === "#") {
      page = "Home";
    } else {
      page = String(page).charAt(0).toUpperCase() + String(page).toLowerCase().slice(1);
    }
    console.log(page, this.props.user.emp_id)
    analytics.page(page, {
      title: page,
      path: page,
    }, {
      userId: String(this.props.user.emp_id),
    })
    console.log("logged to segment successfully")
    this.setState({ loggedToSegment: true });
  }

  async componentDidMount() {
    this.setState({ mapRender: this.props.mapRender || 'task' })
    await this.props.checkTokenExpiry();
    await this.logToSegment();

    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept, Authorization",
      "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
      "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
      Authorization:
        "Bearer " + window.localStorage.getItem("Fw4_access_Token"),
    };

    if (this.state.mapRender === 'task') {
      await this.getTaskData();
    }
    if (this.state.mapRender === 'proj') {
      await this.getProjData();
    }
    if (this.state.mapRender === 'con') {
      await this.getContData();
    }
    if (this.state.mapRender === 'cust') {
      await this.getCustData();
    }
    if (this.state.mapRender === 'emp') {
      await this.getEmpData();
    }
    if (this.state.mapRender === 'note') {
      await this.getNoteData();
    }
    if (this.state.mapRender === 'loc') {
      await this.getLocData();
    }
    if (this.state.mapRender === 'bulk') {
      await this.getBulkData();
    }
    if (this.state.mapRender === 'act') {
      await this.getActData();
    }
    if (this.state.mapRender === 'intake') {
      await this.getIntakeData();
    }
    if (this.state.mapRender === 'workflow') {
      await this.getWorkflowData();
    }

    this.setState({ isLoading: false });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.mapRender !== this.state.mapRender) {
      this.setState({ isLoading: true });

      if (this.state.mapRender === 'task') {
        await this.getTaskData();
      }
      if (this.state.mapRender === 'proj') {
        await this.getProjData();
      }
      if (this.state.mapRender === 'con') {
        await this.getContData();
      }
      if (this.state.mapRender === 'cust') {
        await this.getCustData();
      }
      if (this.state.mapRender === 'emp') {
        await this.getEmpData();
      }
      if (this.state.mapRender === 'note') {
        await this.getNoteData();
      }
      if (this.state.mapRender === 'loc') {
        await this.getLocData();
      }
      if (this.state.mapRender === 'bulk') {
        await this.getBulkData();
      }
      if (this.state.mapRender === 'act') {
        await this.getActData();
      }
      if (this.state.mapRender === 'intake') {
        await this.getIntakeData();
      }
      if (this.state.mapRender === 'workflow') {
        await this.getWorkflowData();
      }

      this.setState({ isLoading: false });
    }
  }

  getSdrOnboardingData = async () => {
    this.setState({
      renderComponent: (
        <div style={{ marginLeft: '10px', contentAlign: 'center' }}>
          <SDRUploadForm comp_id={this.props.comp_id} user={this.props.user} />
        </div>
      )
    })
  }


  getTaskData = async () => {
    let data = {
      employees: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/employeeslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      projects: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/projectslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      locations: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/locationslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
    };

    this.setState({ ...data });

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "task" ? "show active" : ""
            }`}
          id="list-home"
          role="tabpanel"
          aria-labelledby="list-home-list"
          style={{ marginLeft: '5px' }}
        >
          <TaskForm_v2
            {...this.props}
            isFormValidated={this.isFormValidated}
            mapRender={this.state.mapRender}
            empList={data.employees.list}
            locList={data.locations.list}
            projList={data.projects.list}
            updateMapRender={this.state.mapRender}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getProjData = async () => {
    try {
      const [employeesRes, empStatusRes, frequencyRes, customersRes, contactsRes, locationsRes, payersRes] = await Promise.all([
        axios.get(APIURL + "/dropdowns/dropdownType/employeeslist", { params: { comp_id: this.props.comp_id } }),
        axios.get(APIURL + "/dropdowns/dropdownType/empStatus", { params: { comp_id: this.props.comp_id } }),
        axios.get(APIURL + "/config/defaults", { params: { feature_type: "payrollFrequency" } }),
        axios.get(APIURL + "/dropdowns/dropdownType/customerslist", { params: { comp_id: this.props.comp_id } }),
        axios.get(APIURL + "/dropdowns/dropdownType/contactslist", { params: { comp_id: this.props.comp_id } }),
        axios.get(APIURL + "/dropdowns/dropdownType/locationslist", { params: { comp_id: this.props.comp_id } }),
        axios.get(APIURL + "/associate_payer", { params: { compId: this.props.comp_id } }),
      ]);

      const data = {
        employees: {
          list: employeesRes.data,
          empStatus: empStatusRes.data,
          currency: [],
          frequency: frequencyRes.data,
        },
        customers: { list: customersRes.data },
        contacts: { list: contactsRes.data },
        locations: { list: locationsRes.data },
        payers: { list: (payersRes.data || []).filter(p => p.id) },
      };

      this.setState(prev => ({
        ...prev,
        ...data,
        renderComponent: (
          <div
            className={`tab-pane fade ${this.state.mapRender === "proj" ? "show active" : ""}`}
            id="list-profile"
            role="tabpanel"
            aria-labelledby="list-profile-list"
            style={{ marginLeft: '5px' }}
          >
            <ProjectForm
              {...this.props}
              isFormValidated={this.isFormValidated}
              mapRender={this.state.mapRender}
              customerList={data.customers.list}
              empList={data.employees.list}
              contactList={data.contacts.list}
              locList={data.locations.list}
              payerList={data.payers.list}
              empStatus={data.employees.empStatus}
              currency={data.employees.currency}
              frequency={data.employees.frequency}
              comp_id={this.props.comp_id}
            />
          </div>
        )
      }));
    } catch (err) {
      console.error('Failed to load project form dropdown data', err);
      this.setState({ renderComponent: <div style={{ padding: '1rem', color: 'red' }}>Failed to load data for Project Form.</div> });
    }
  }

  getContData = async () => {
    let data = {};

    this.setState({ ...data });

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "con" ? "show active" : ""
            }`}
          id="list-messages"
          role="tabpanel"
          aria-labelledby="list-messages-list"
          style={{ marginLeft: '5px' }}
        >
          <ContactForm
            {...this.props}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getCustData = async () => {
    let data = {
      employees: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/employeeslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      customers: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/customerslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        customerType: (
          await axios.get(APIURL + "/dropdowns/dropdownType/customerType", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        customerStatus: (
          await axios.get(APIURL + "/dropdowns/dropdownType/customerStatus", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      locations: {
        states: [],
      },
    };

    this.setState({ ...data });

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "cust" ? "show active" : ""
            }`}
          id="list-settings"
          role="tabpanel"
          aria-labelledby="list-settings-list"
          style={{ marginLeft: '5px' }}
        >
          <CustomerForm
            {...this.props}
            isFormValidated={this.isFormValidated}
            states={data.locations.states}
            customerType={data.customers.customerType}
            customerStatus={data.customers.customerStatus}
            empList={data.employees.list}
            customerList={data.customers.list}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getEmpData = async () => {
    let data = {
      employees: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/employeeslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        empType: [],
        empLevel: (
          await axios.get(APIURL + "/dropdowns/dropdownType/empLevel", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        empStatus: (
          await axios.get(APIURL + "/dropdowns/dropdownType/empStatus", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      locations: {
        states: [],
      },
    };

    this.setState({ ...data });

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "emp" ? "show active" : ""
            }`}
          id="list-employee"
          role="tabpanel"
          aria-labelledby="list-employee-list"
        >
          <EmployeeForm
            {...this.props}
            isFormValidated={this.isFormValidated}
            states={this.state.locations.states}
            empList={this.state.employees.list}
            empStatus={this.state.employees.empStatus}
            empType={this.state.employees.empType}
            empLevel={this.state.employees.empLevel}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getNoteData = async () => {
    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "note" ? "show active" : ""
            }`}
          id="list-home"
          role="tabpanel"
          aria-labelledby="list-home-list"
          style={{ marginLeft: '5px' }}
        >
          <div>
            {!this.state.showNoteCreated &&
              <NoteFormv2
                {...this.props}
                user={this.props.user}
                comp_id={this.props.comp_id}
                mode='add'
                twoColumn
                onSubmit={(val) => {
                  console.log(val)
                  this.setState({ showNoteCreated: val })
                }}
                handleClose={() => this.handleChangePage("note")}
              />
            }
            {this.state.showNoteCreated &&
              <MsgModalBox addNew={() => this.setState({ showNoteCreated: false })} goHome={() => this.setState({ goHome: true })} text="Note" showError={null} style={{ position: "absolute" }} />
            }
          </div>
        </div>
      )
    });
  }

  getLocData = async () => {
    let data = {
      locations: {
        states: [],
        locType: (
          await axios.get(APIURL + "/dropdowns/dropdownType/locType", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        locStatus: (
          await axios.get(APIURL + "/dropdowns/dropdownType/locStatus", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
    };

    this.setState({ ...data });

    console.log(data, "temp check");

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "loc" ? "show active" : ""
            }`}
          id="list-location"
          role="tabpanel"
          aria-labelledby="list-location-list"
          style={{ width: '45%', marginLeft: '10px' }}
        >
          <LocationForm
            {...this.props}
            isFormValidated={this.isFormValidated}
            mapRender={this.state.mapRender}
            states={data.locations.states}
            locStatus={data.locations.locStatus}
            locType={data.locations.locType}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getBulkData = async () => {
    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "bulk" ? "show active" : ""
            }`}
          id="list-bulkupload"
          role="tabpanel"
          aria-labelledby="list-bulkupload-list"
          style={{ width: '45%', marginLeft: '10px' }}
        >
          <BulkUploadv2 {...this.props} comp_id={this.props.comp_id} />
        </div>
      )
    });
  }

  getActData = async () => {
    let data = {
      employees: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/employeeslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      projects: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/projectslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      tasks: {
        taskType: (
          await axios.get(APIURL + "/dropdowns/dropdownType/taskType", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
      locations: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/locationslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        states: [],
        locType: (
          await axios.get(APIURL + "/dropdowns/dropdownType/locType", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
        locStatus: (
          await axios.get(APIURL + "/dropdowns/dropdownType/locStatus", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      },
    };

    console.log(data, "temp check");

    this.setState({ ...data });

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "act" ? "show active" : ""
            }`}
          id="list-record-activity"
          role="tabpanel"
          aria-labelledby="list-location-list"
          style={{ width: '45%', marginLeft: '10px' }}
        >
          <RecordActivity
            {...this.props}
            user={this.props.user}
            isFormValidated={this.isFormValidated}
            taskType={data.tasks.taskType}
            projects={data.projects.list}
            locations={data.locations.list}
            employees={data.employees.list}
            mapRender={this.state.mapRender === "rec"}
            states={data.locations.states}
            locStatus={data.locations.locStatus}
            locType={data.locations.locType}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getIntakeData = async () => {
    let data = {
      customers: {
        list: (
          await axios.get(APIURL + "/dropdowns/dropdownType/customerslist", {
            params: { comp_id: this.props.comp_id },
          })
        ).data,
      }
    };

    this.setState({ ...data });

    this.setState({
      renderComponent: (
        <div
          className={`tab-pane fade ${this.state.mapRender === "intake" ? "show active" : ""}`}
          id="list-intake"
          role="tabpanel"
          aria-labelledby="list-intake-list"
          style={{ width: '45%', marginLeft: '7px' }}
        >
          <IntakeForm
            {...this.props}
            customerList={this.state.customers.list}
            comp_id={this.props.comp_id}
          />
        </div>
      )
    });
  }

  getWorkflowData = async () => {
    this.setState({
      renderComponent: (
        <div style={{ width: '45%', marginLeft: '10px' }}>
          <WorkflowForm
            {...this.props}
            handleClose={() => this.handleChangePage("workflow")}
          />
        </div>
      )
    });
  }


  isFormValidated = (objForVal) => {
    console.log('>>>>>>>>>>> ', objForVal)
    var missingField = {
      isValidated: true
    }
    let temp = Object.keys(objForVal)
    console.log(temp);

    // Check if task description is mandatory based on company settings
    const taskDescriptionIsMandatory = this.props.user?.comp_settings?.find(
      setting => setting.feature_id === 74 && setting.feature_value === 'true'
    );

    if (temp[0] === 'selectedEmp') {

      let selectedEm = objForVal.selectedEmp
      for (let i = 0; i < selectedEm.length; i++) {
        for (let objKey in selectedEm[i]) {
          if (
            selectedEm[i][objKey] === "" ||
            selectedEm[i][objKey] === undefined ||
            selectedEm[i][objKey].length === 0
          ) {
            missingField.isValidated = false;
            missingField.missingKey = objKey
            return missingField
          }
        }
      }
    }

    for (let objKey in objForVal) {
      if ((objKey !== "Cemail" && objKey !== "designation") &&
        (objForVal[objKey] === "" ||
          objForVal[objKey] === undefined ||
          objForVal[objKey].length === 0)
      ) {
        if (
          objKey === "address2" ||
          objKey === "location_addr2" ||
          objKey === "tComment" ||
          (objKey === "tDesc" && !taskDescriptionIsMandatory) ||
          objKey === "cus_local_id" ||
          objKey === "address_line_2" ||
          objKey === "pSelfPay" ||
          objKey === "pPrimaryPayer" ||
          objKey === "pSecondaryPayer" ||
          objKey === "medicaid_id" ||
          objKey === "medicaid_eligible" ||
          objKey === "sign_page_date" ||
          objKey === "last_plan_approval_date" ||
          objKey === "last_assess_date" ||
          objKey === "renewal_date" ||
          objKey === "personal_days_off" ||
          objKey === "vacation_days" ||
          objKey === "DDD_tier" ||
          objKey === "diagnose_code" ||
          objKey === "func_criteria_met" ||
          objKey === "waiver_program" ||
          objKey === "NJCATBehavioral" ||
          objKey === "NJCATFCA" ||
          objKey === "NJCATMedical" ||
          objKey === "NJCATSelfcare" ||
          objKey === "County" ||
          objKey === "Race" ||
          objKey === "Ethnicity" ||
          objKey === "MedicaidEndDate" ||
          objKey === "AgencyAssignDate" ||
          objKey === "TransferOutReason" ||
          objKey === "TransferOutDate" ||
          objKey === "tContacts" ||
          objKey === "tTravelTime" ||
          objKey === "tExpenses" ||
          objKey === "pro_program_id" ||
          objKey === "place01char" ||
          objKey === "place02char" ||
          objKey === "place03char" ||
          objKey === "place04date" ||
          objKey === "place05date" ||
          objKey === "place06number" ||
          objKey === "place07number"
        ) {
          continue;
        } else if (objForVal["cus_is_company"] === true && objForVal["company_name"] === "") {
          missingField.isValidated = false;
          missingField.missingKey = "company_name"
          return missingField;
        }
        else {
          console.log(objKey);

          if (
            (objKey === "company_name" &&
              objForVal["first_name"] !== "" &&
              objForVal["last_name"] !== "") ||
            ((objKey === "first_name" || objKey === "last_name") &&
              objForVal["company_name"] !== "" && objForVal["company_name"] !== undefined) || objKey === "address_maps"
          ) {
            continue;
          } else {
            missingField.isValidated = false;
            missingField.missingKey = objKey
            return missingField;
          }
        }
      } else if (objKey === "prefCommMode") {
        if (objForVal[objKey] !== "Email" && objForVal[objKey] !== "Phone") {
          missingField.isValidated = false;
          missingField.missingKey = "prefCommMode"
          return missingField;
        } else if (objForVal[objKey] === "Email" && !String(objForVal["Cemail"]).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          missingField.isValidated = false;
          missingField.missingKey = "prefCommMode";
          missingField.invalidKey = "Cemail";
          return missingField;
        } else if (objForVal[objKey] === "Phone") {
          let phoneNumPresent = false;
          objForVal["phnNumList"].forEach((phoneDets) => {
            if (/^\d{10}$/.test(phoneDets.phone)) {
              phoneNumPresent = true;
            }
          })
          if (!phoneNumPresent) {
            missingField.isValidated = false;
            missingField.missingKey = "prefCommMode";
            missingField.invalidKey = "phnNumList";
            return missingField;
          }
        }
      } else if (Array.isArray(objForVal[objKey])) {
        let arrValid = objForVal[objKey].every(function (objTesting) {
          for (let objTestKey in objTesting) {
            if (
              objTesting[objTestKey] === "" ||
              objTesting[objTestKey] === undefined
            ) {
              if (
                objTestKey === "address_line_2" ||
                objTestKey === "location_addr2"
              ) {
                continue;
              } else {
                missingField.isValidated = false;
                missingField.missingKey = objKey
                return missingField;
              }
            }
          }
          return true;
        });
        if (!arrValid) return false;
      } else if (objKey === "active_plan_version") {
        for (const digit of objForVal[objKey]) {
          if (Number.isNaN(parseInt(digit)) && digit !== ".") {
            alert("PROJECT ACTIVE PLAN VERSION has to be a number");
            objForVal[objKey] = "";
            return false;
          }
        }
      }
    }

    return missingField;
  };

  handleChangePage = (key) => {
    this.setState({ mapRender: key, isLoading: true }, async () => {
      switch (key) {
        case "sdr-onboarding":
          await this.getSdrOnboardingData();
          break;
        case "task":
          await this.getTaskData();
          break;
        case "proj":
          await this.getProjData();
          break;
        case "con":
          await this.getContData();
          break;
        case "cust":
          await this.getCustData();
          break;
        case "emp":
          await this.getEmpData();
          break;
        case "note":
          await this.getNoteData();
          break;
        case "loc":
          await this.getLocData();
          break;
        case "bulk":
          await this.getBulkData();
          break;
        case "act":
          await this.getActData();
          break;
        case "intake":
          await this.getIntakeData();
          break;
        default:
          break;
      }
      this.setState({ isLoading: false });
    });
  };

  renderContent = () => {
    if (this.state.isLoading) {
      return (
        <Box
          sx={{
            marginTop: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <CircularProgress />
        </Box>
      );
    }
    return this.state.renderComponent;
  };

  render() {
    return (
      <Box sx={{ flexGrow: 1, height: "100%" }}>
        <AppBar position="static" color="default" sx={{ boxShadow: "none", borderBottom: "1px solid #ccc" }}>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <h4 style={{ color: '#212529' }}>Create</h4>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ToolbarAction title="Onboarding & Ingestion (AI Agent)" label="Onboarding" icon={<AssistantIcon />} active={this.state.mapRender === "sdr-onboarding"} onClick={() => this.handleChangePage("sdr-onboarding")} />
              <ToolbarAction title="Task" label="Task" icon={<TaskIcon />} active={this.state.mapRender === "task"} onClick={() => this.handleChangePage("task")} />
              {this.props.user.permissions.CreateNewProject && (
                <ToolbarAction title="Project / Plan" label="Project" icon={<ListAltIcon />} active={this.state.mapRender === "proj"} onClick={() => this.handleChangePage("proj")} />
              )}
              <ToolbarAction title="Contact / Provider" label="Contact" icon={<PersonIcon />} active={this.state.mapRender === "con"} onClick={() => this.handleChangePage("con")} />
              {this.props.user.permissions.CreateNewCustomer && (
                <ToolbarAction title="Customer / Patient" label="Customer" icon={<BusinessIcon />} active={this.state.mapRender === "cust"} onClick={() => this.handleChangePage("cust")} />
              )}
              <ToolbarAction title="Note" label="Note" icon={<NoteIcon />} active={this.state.mapRender === "note"} onClick={() => this.handleChangePage("note")} />
              <ToolbarAction title="Location" label="Location" icon={<LocationOnIcon />} active={this.state.mapRender === "loc"} onClick={() => this.handleChangePage("loc")} />
              {this.props.user.type === "Admin" && (
                <ToolbarAction title="Bulk Upload" label="Bulk Upload" icon={<UploadIcon />} active={this.state.mapRender === "bulk"} onClick={() => this.handleChangePage("bulk")} />
              )}
              <ToolbarAction title="Record Activity" label="Activity" icon={<AssignmentIcon />} active={this.state.mapRender === "act"} onClick={() => this.handleChangePage("act")} />
              {this.props.user.permissions.CreateIntake && (
                <ToolbarAction title="Intake Form" label="Intake" icon={<FileCopyIcon />} active={this.state.mapRender === "intake"} onClick={() => this.handleChangePage("intake")} />
              )}
              {this.props.user.permissions.CreateNewWorkflow && (
                <ToolbarAction title="Workflow" label="Workflow" icon={<AccountTreeOutlinedIcon />} active={this.state.mapRender === "workflow"} onClick={() => this.handleChangePage("workflow")} />
              )}
            </Box>
          </Toolbar>
        </AppBar>

        <Container
          disableGutters
          maxWidth={false} // Disable the default maxWidth constraint
          sx={{
            width: "100%", // Ensure the container takes up the full width
            mt: 2,
            mb: 2,
            overflowY: "auto", // Allow scrolling for the entire container if needed
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%", // Ensure the content takes up the full width
              paddingLeft: "16px", // Add some padding to the left for spacing
              paddingRight: "16px", // Optional: Add padding to the right for consistency
            }}
          >
            {this.renderContent()}
          </Box>
        </Container>

        {this.state.goHome && <Redirect to="/" />}
      </Box>
    );
  }
}

export default SideBar;
